'use client';

import * as Sentry from '@sentry/nextjs';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { PageErrorMsg } from '@/app/components/shared/PageErrorMsg';
import { getFetchErrorMsg } from '@/app/utils/client';

export default function CreateVideoError({ error }: { error: Error }) {
  const t = useTranslations();

  useEffect(() => {
    Sentry.withScope((scope) => {
      scope.setLevel('error');
      scope.setTag('errorType', 'createPageError');
      scope.setTag('page', 'create');
      Sentry.captureException(error);
    });
  }, [error]);

  return <PageErrorMsg message={getFetchErrorMsg(error, t)} />;
}
